import { render, staticRenderFns } from "./2.vue?vue&type=template&id=2d27f8fa&scoped=true&"
var script = {}
import style0 from "./2.vue?vue&type=style&index=0&id=2d27f8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27f8fa",
  null
  
)

export default component.exports